import React, { useState } from "react";

const Img = ({
  className,
  src = "images/abstract_placeholder.jpeg",
  alt = "testImg",
  ...restProps
}) => {
  const [source,setSource] = useState(src);
  return (
    <img
      className={className}
      src={source??"images/abstract_placeholder.jpeg"}
      onError={event => {
        setSource('images/abstract_placeholder.jpeg');
      }}
      alt={alt}
      {...restProps}
      loading={"lazy"}
    />
  );
};
export { Img };
